import { gatewayConfig } from "@courses-utils/gateway-auth/src/ts/config";

/**
 * Specification of options available when redirecting the user to the
 * LoginConnector.
 */
type LoginConnectorOptions = {
    /**
     * Optionally specifies an absolute url, which the user will be redirected
     * to after having successfully signed in.
     */
    successUrl?: string;

    /**
     * Optionally specifies an absolute url, which the user will be redirected
     * to if something goes wrong during login.
     */
    failureUrl?: string;
};

/**
 * Helper that redirects the user to the LoginConnector page, making sure that
 * he'll be signed out of any active accounts.
 *
 * @param clientName The name of the application/client to use to identify the
 *                   user within the LoginConnector.
 */
export function signOutFromLoginConnector(profile: string, options: LoginConnectorOptions, returnUrl: true): string;
export function signOutFromLoginConnector(profile: string, options?: LoginConnectorOptions): void;
export function signOutFromLoginConnector(profile: string, options: LoginConnectorOptions = {}, returnUrl?: true): void | string {
    // We need to encode success and failure urls, to ensure that they're going
    // to be properly caught by the remote backend
    const failureUrl = encodeURIComponent(options.failureUrl || window.location.href);
    const successUrl = encodeURIComponent(options.successUrl || window.location.href);

    // Prepare the base url, which we're going to send the user to in order to
    // sign him in
    const url = [
        `${gatewayConfig.loginConnectorUrl}/Navigator/Logout`,
        `?clientWebSite=${profile}`,
        `&logoutSuccessUrl=${successUrl}`,
        `&logoutFailureUrl=${failureUrl}`,
    ];

    // Now we just need to actually redirect the user to the LoginConnector
    if (!returnUrl) {
        window.location.href = url.join("");
    } else {
        return url.join("");
    }
}
